<template>
  <div :key="keyForm">
    <div class="mb-5" v-for="(form, index) in formularioDinamico" :key="form.id">
      
        <h2 class="form-title mb-5">{{ form.titulo }} 
          <v-badge location="top right" color="error" content="NOVO">
            
            <v-icon icon="mdi-cog"></v-icon>
          </v-badge>
        </h2>

        <div :class="`${ form.col || 'col-xs-12'}`">

          <div class="row" v-for="(linha, i) in agrupadoPorLinha(form)" :key="i">
            <template v-for="(listaDeCampos, index) in linha">

              <div
                v-if="
                  listaDeCampos.type != 'hidden' &&
                  listaDeCampos.type == 'textarea' &&
                  listaDeCampos.mascara == null &&
                  verificadorCondicional(listaDeCampos.show, listaDeCampos) &&
                  handleRegrasDadosExternos(listaDeCampos)
                "
                :key="`${listaDeCampos.type}_${listaDeCampos.name}`"
                :class="`${listaDeCampos.col} form-field-dynamic`"
              >
                <v-textarea
                  :name="listaDeCampos.name"
                  :label="`${listaDeCampos.label} ${inputEhObrigatorio(listaDeCampos.validation)}`"
                  v-model="values[listaDeCampos.name]"
                  rows="3"
                  dense
                  outlined
                  :readonly="!!(listaDeCampos.readonly || listaDeCampos.computed)"
                  :disabled="!!(listaDeCampos.readonly || listaDeCampos.computed)"
                />
              </div>
              <div
                v-else-if="
                  listaDeCampos.type != 'hidden' &&
                  (listaDeCampos.type == 'text' ||
                  listaDeCampos.type == 'url' ||
                  listaDeCampos.type == 'number') &&
                  listaDeCampos.mascara == null &&
                  verificadorCondicional(listaDeCampos.show, listaDeCampos) &&
                  handleRegrasDadosExternos(listaDeCampos)
                "
                :key="`${listaDeCampos.type}_${listaDeCampos.name}`"
                :class="`${listaDeCampos.col} form-field-dynamic`"
              >
                <v-text-field
                  :name="listaDeCampos.name"
                  :type="listaDeCampos.type"
                  :label="`${listaDeCampos.label} ${inputEhObrigatorio(listaDeCampos.validation)}`"
                  v-model="values[listaDeCampos.name]"
                  dense
                  outlined
                  :readonly="!!(listaDeCampos.readonly || listaDeCampos.computed)"
                  :disabled="!!(listaDeCampos.readonly || listaDeCampos.computed)"
                />
              </div>
              <div
                v-else-if="
                  listaDeCampos.type != 'hidden' &&
                  (listaDeCampos.type == 'text' ||
                  listaDeCampos.type == 'url' ||
                  listaDeCampos.type == 'number') &&
                  listaDeCampos.mascara != null &&
                  verificadorCondicional(listaDeCampos.show, listaDeCampos) &&
                  handleRegrasDadosExternos(listaDeCampos)
                "
                :key="`${listaDeCampos.type}_${listaDeCampos.name}_mask`"
                :class="`${listaDeCampos.col} form-field-dynamic`"
              >
                <v-text-field
                  :name="listaDeCampos.name"
                  :type="listaDeCampos.type"
                  :label="`${listaDeCampos.label} ${inputEhObrigatorio(listaDeCampos.validation)}`"
                  v-model="values[listaDeCampos.name]"
                  dense
                  outlined
                  v-mask="`${ listaDeCampos.mascara }`"
                  :readonly="listaDeCampos.readonly || false"
                />
              </div>
              <input v-else-if="
                  listaDeCampos.type == 'hidden' &&
                  listaDeCampos.type != 'text' &&
                  listaDeCampos.type != 'select' &&
                  listaDeCampos.type != 'textarea' &&
                  verificadorCondicional(listaDeCampos.show, listaDeCampos) &&
                  handleRegrasDadosExternos(listaDeCampos)
                "
                :type="listaDeCampos.type"
                :name="listaDeCampos.name  + '_' + index"
                :key="listaDeCampos.name+'_keyhiddentxtipt_'+idx"
                :value="values[listaDeCampos.name] = listaDeCampos.value"
              />

              <ComboboxInputComponent
                v-else-if="
                  listaDeCampos.type == 'select' &&
                  verificadorCondicional(listaDeCampos.show, listaDeCampos) &&
                  handleRegrasDadosExternos(listaDeCampos)
                "
                :name="listaDeCampos.name"
                :type="listaDeCampos.type"
                :label="`${listaDeCampos.label} ${inputEhObrigatorio(listaDeCampos.validation)}`"
                :options="listaDeCampos.options"
                :class="`${listaDeCampos.col} form-field-dynamic`"
                :key="`${listaDeCampos.name}_id`"
                v-model="values[listaDeCampos.name]"
                @update="inputCallback"
                @validation="verificadorDeValidacao"
                :validation-name="listaDeCampos.label"
              ></ComboboxInputComponent>

              <ComboboxInputComponent
                v-else-if="
                  listaDeCampos.type == 'select-agrupado' &&
                  verificadorCondicional(listaDeCampos.show, listaDeCampos) &&
                  handleRegrasDadosExternos(listaDeCampos)
                "
                :name="listaDeCampos.name"
                :type="listaDeCampos.type"
                :label="`${listaDeCampos.label} ${inputEhObrigatorio(listaDeCampos.validation)}`"
                :options="filtrarOpcoesPorGrupo(listaDeCampos)"
                :class="`${listaDeCampos.col} form-field-dynamic`"
                :key="`${listaDeCampos.name}_agrupado_${values[listaDeCampos.name]}`"
                v-model="values[listaDeCampos.name]"
                @update="inputCallback"
                @validation="verificadorDeValidacao"
                :validation-name="listaDeCampos.label"
              ></ComboboxInputComponent>

              <ComboboxInputComponent
              v-else-if="
                listaDeCampos.type == 'select-avancado' &&
                verificadorCondicional(listaDeCampos.show, listaDeCampos) &&
                handleRegrasDadosExternos(listaDeCampos)
              "
              :name="listaDeCampos.name"
              :type="listaDeCampos.type"
              :label="listaDeCampos.label"
              :options="listaDeCampos.options[retornaValorEnderecamento(listaDeCampos.nome_enderecamento)]"
              :class="[listaDeCampos.col]"
              :key="listaDeCampos.id"
              v-model="values[listaDeCampos.name]"
              @update="inputCallback"
            ></ComboboxInputComponent>

              <AutocompleteComponent
                v-else-if="
                  listaDeCampos.type == 'autocomplete' &&
                  verificadorCondicional(listaDeCampos.show, listaDeCampos) &&
                  handleRegrasDadosExternos(listaDeCampos)
                "
                :name="listaDeCampos.name"
                :type="listaDeCampos.type"
                :label="`${listaDeCampos.label} ${inputEhObrigatorio(listaDeCampos.validation)}`"
                :options="listaDeCampos.options"
                :class="`${listaDeCampos.col} form-field-dynamic`"
                :key="`autocomplete_${listaDeCampos.name}_${itemForm.id}_${listaDeCampos.options.length}`"
                v-model="values[listaDeCampos.name]"
                @update="inputCallback"
                @validation="verificadorDeValidacao"
                :validation="listaDeCampos.validation"
                :validation-name="listaDeCampos.name"
                :loading="listaDeCampos.options == 0"
                
              ></AutocompleteComponent>

              <RadioInputComponent
                v-else-if="listaDeCampos.type == 'radio' &&
                  handleRegrasDadosExternos(listaDeCampos)"
                :name="listaDeCampos.name"
                :label="`${listaDeCampos.label} ${inputEhObrigatorio(listaDeCampos.validation)}`"
                :options="listaDeCampos.options"
                :class="`${listaDeCampos.col} form-field-dynamic`"
                :validation="listaDeCampos.validation"
                :key="'radio_'+listaDeCampos.name"
                v-model="values[listaDeCampos.name]"
                @update="inputCallback"
                @validation="verificadorDeValidacao"
                :validation-name="listaDeCampos.label"
              >
              </RadioInputComponent>

              <DateInputComponent
                v-else-if="
                  (listaDeCampos.type == 'date' ||
                  listaDeCampos.type == 'time' ||
                  listaDeCampos.type == 'date-time' ||
                  listaDeCampos.type == 'datetime-local') &&
                  verificadorCondicional(listaDeCampos.show, listaDeCampos) &&
                  handleRegrasDadosExternos(listaDeCampos)
                "
                :name="listaDeCampos.name"
                :type="listaDeCampos.type == 'date-time' ? 'datetime-local' : listaDeCampos.type"
                :label="`${listaDeCampos.label} ${inputEhObrigatorio(listaDeCampos.validation)}`"
                :validation="listaDeCampos.validation"
                :placeholder="listaDeCampos.placeholder"
                :class="`${listaDeCampos.col} form-field-dynamic`"
                :key="listaDeCampos.id"
                v-model="values[listaDeCampos.name]"
                @update="inputCallback"
                @validation="verificadorDeValidacao"
                :validation-name="listaDeCampos.label"
              />  
              
              <SGPFormAutocompleteComponent
                v-else-if="
                  listaDeCampos.type == 'requisicao' &&
                  verificadorCondicional(listaDeCampos.show, listaDeCampos) &&
                  handleRegrasDadosExternos(listaDeCampos)
                "
                :name="listaDeCampos.name"
                :label="`${listaDeCampos.label} ${inputEhObrigatorio(listaDeCampos.validation)}`"
                :listaDeOptions="listaDeCampos.options"
                optionLabel="label"
                optionValue="value"
                :class="`${listaDeCampos.col} input-requisicao`"
                :key="`${listaDeCampos.type}_${listaDeCampos.name}_${keyForm}`"
                v-model="values[listaDeCampos.name]"
                mostrarSelecione
                @update="inputCallback"
                @validation="verificadorDeValidacao"
                :validation-name="listaDeCampos.label"
                class="margin-top-6"
              />

            </template>
          </div>

        </div>
        <div v-if="!multiplo">
          <div class="mt-2">
            <SGPFormBotaoComponent
              v-if="exportarDados && index == (formularioDinamico.length - 1)"
              @click="exibeValue()">
              Salvar
            </SGPFormBotaoComponent>
          </div>
          <div class="mt-2"><small>Campos com * são obrigatórios.</small></div>
        </div>
    </div>
  </div>
</template>

<script>
// import TexInputComponent from '../../formularios/components/TexInputComponent.vue';
import RadioInputComponent from './components/RadioInputComponent.vue';
import ComboboxInputComponent from './components/ComboboxInputComponent.vue';
import DateInputComponent from './components/DateInputComponent.vue';
import AutocompleteComponent from './components/AutocompleteComponent.vue';
import moment from 'moment';

import HttpClient from '@/common/boot/HttpClient'
import { mapActions, mapGetters } from 'vuex';
import criarToast from '@/common/boot/ToastsHandler'
import { processarCampoComputado, criarMapaDependencias } from '../../service/CamposComputadosService'

export default {
  name: "RenderizacaoFormularioDinamicoComponent",

  components: {
    // TexInputComponent,
    RadioInputComponent,
    ComboboxInputComponent,
    DateInputComponent,
    AutocompleteComponent
  },

  props: {
    // json: {
    //   type: String,
    //   required: false,
    //   default: ''
    // },

    arrayFormId: {
      type: [Array, Number],
      required: true,
      default: undefined
    },

    exportarDados: {
      type: Boolean,
      required: false,
      default: false
    },

    multiplo: {
      type: Boolean,
      required: false,
      default: false
    },

    endpoint: {
      type: String,
      required: false,
      default: () => ''
    },

    dadosExternos: {
      type: [Boolean, Object],
      required: false,
      default: false
    }
  },

  data () {
    return {
      values: {},
      keyForm: '',
      formularioCache: '',
      validation: [],
      mapaDependencias: {}
    }
  },

  async created () {
    if (this.$props.arrayFormId && this.$props.arrayFormId.length < 2) {
      // console.log('Array de formulários: ', this.$props.arrayFormId)
      await this.$props.arrayFormId.forEach(async form => {
        await this.recuperarFormularioDinamicoPorId({ id: form.ctrl_formulario_dinamico_id })
        await this.initComponentData()
      }) 
    } else {
      await this.recuperarListaDeFormulariosDinamicoPorId(this.$props.arrayFormId)
      await this.initComponentData()
    }
  },

  async mounted () {
    this.keyForm = true
  },

  computed: {
    ...mapGetters('ctrlFormularioDinamico', [
      'formularioDinamico',
      'loadingFormularioDinamico'
    ]),

    form () {
      if (this.formularioDinamico) {
        return [...this.formularioDinamico]
      }

      return []
    },

    
  },

  methods: {
    ...mapActions('ctrlFormularioDinamico', [
      'recuperarListaDeFormulariosDinamicoPorId',
      'recuperarFormularioDinamicoPorId',
      'inserirOptionsFormularioDinamico'
    ]),

    async initComponentData () {
      await this.setarVariaveisDoFormulario()
      this.criarMapaDependenciasCampos()
      this.processarCamposComputados()
      this.setarVariaveisMinimizado()
      this.requestDadosDoCampo()
      this.recuperarFormularioAtualizacaoCache()
    },

    agrupadoPorLinha(form) {

      // if (form) {
      //   console.log('Entrou no formulário: ', form)
      //   return
      // }

      const resultado = {};

      if (form && Object.keys(form).length) {
        form.corpo.forEach(obj => {
          if (!resultado[obj.linha]) {
            resultado[obj.linha] = []
          }
          resultado[obj.linha].push(obj);
        })
      }

      return resultado;
    },

    recuperarFormularioAtualizacaoCache () {
      const formularioDinamico = localStorage.getItem(process.env.VUE_APP_FORMULARIO_DINAMICO_MINIMIZADO + '_atualizacao')
      
      if (formularioDinamico) {
        const formulario = JSON.parse(formularioDinamico)
        this.$nextTick(() => {
          this.values = formulario.values ? formulario.values : {}
        })

      }
    },

    filtrarOpcoesPorGrupo (campo) {
      const opcoes = (campo.ctrl_campos_opcoes || []).map(o => ({ label: o.label, value: o.val, grupo: o.grupo }))

      if (!campo.show || typeof campo.show !== 'string') {
        return opcoes
      }

      const match = campo.show.match(/(?:this\.values\.|values\.)(\w+)\s*[=!<>]/)
      if (!match) return opcoes

      const campoGatilho = match[1]
      const valorAtual = this.values[campoGatilho]

      if (!valorAtual) return opcoes

      return opcoes.filter(o => o.grupo === valorAtual)
    },

    normalizarExpressao (expr) {
      // Quando múltiplas regras do mesmo campo são unidas com &&
      // (ex: campo == 'a' && campo == 'b'), o resultado é sempre false.
      // Converte para || quando todas as partes referenciam o mesmo campo.
      const partesAnd = expr.split(' && ')
      if (partesAnd.length <= 1) return expr

      const campos = partesAnd.map(parte => {
        const match = parte.match(/(?:this\.values\.|values\.)([\w]+)\s*[=!<>]/)
        return match ? match[1] : null
      })

      if (campos.every(c => c !== null && c === campos[0])) {
        return partesAnd.join(' || ')
      }

      return expr
    },

    verificadorCondicional (val, campo) {
      if (val === null || val === undefined) {
        return true
      }
      
      if (typeof val === 'boolean') {
        return val
      }
      
      if (typeof val === 'string') {
        try {
          const exprNormalizada = this.normalizarExpressao(val)
          const retorno = eval(exprNormalizada)

          if (campo) {
            campo.validation = campo.validation_verify ? campo.validation_verify : campo.validation
            if (!retorno) {
              campo.validation = ""
            }
          }
          
          return retorno
        } catch (error) {
          console.error('Erro ao avaliar condicional:', val, error)
          return true
        }
      }
      
      return !!val
    },

    requestDadosDoCampo() {
      let listaDeDados = []

      this.form.forEach(form => {
        form.corpo.forEach(campo => {
          if (campo.ctrl_campo_endpoint) {
              HttpClient({ method: campo.ctrl_campo_endpoint.metodo, url: campo.ctrl_campo_endpoint.endpoint}).then(response => {
              listaDeDados = response.data.data.map(dados => {
                return {
                  label: dados[campo.ctrl_campo_endpoint.option_label],
                  value: dados[campo.ctrl_campo_endpoint.option_value]
                }
              })

              campo.options = listaDeDados
              this.keyForm = campo.options.length
              this.inserirOptionsFormularioDinamico({ name: campo.name, options: listaDeDados})
            })
          }
        })
      })

      return listaDeDados
    },

    inputEhObrigatorio(validation) {
      if (!validation) return ''
      if (validation.includes('nullable')) return ''
      return '*'
    },

    setarVariaveisDoFormulario () { 
      const keyForm = 'atualizar_formulario';

      let dateTypes = ['date', 'date-time']
      let optionsTypes = ['select', 'select-agrupado', 'radio'];

      this.form.forEach(form => {
        if (form.corpo.length == 0) {
          return false;
        }

        form.corpo.forEach((item) => {
          if (dateTypes.includes(item.type) && item.type == 'date') {          
            this.$set(this.values, item.name, item.data_corrente ? moment(Date.now()).format("YYYY-MM-DD") : '')
            return
          }

          if (dateTypes.includes(item.type) && item.type == 'date-time') {          
            this.$set(this.values, item.name, item.data_corrente ? moment(Date.now()).format("YYYY-MM-DD HH:mm:ss") : '')
            return
          }

          if (optionsTypes.includes(item.type)) {
            this.$set(this.values, item.name, item.value ? item.value : '')
            return
          }

          this.$set(this.values, item.name, item.value || '')
        })
      })

      this.keyForm = keyForm

      return true;
    },

    inputCallback (val) {
      if (val && typeof val === 'object' && 'name' in val && 'model' in val) {
        const valorCopiado = { ...this.values }
        valorCopiado[val.name] = val.model
        this.values = valorCopiado
      }
      if (!val || !val.name) {
        return
      }
      
      const valorCopiado = { ...this.values }
      valorCopiado[val.name] = val.model
      this.values = valorCopiado
      
      // Atualizar campos computados que dependem deste campo
      this.atualizarCamposComputadosDependentes(val.name)
    },

    retornaValorEnderecamento(enderecamento) {
      /* O endereçamento representa e o vinculo com os campos que possibilita a captura do valor deles */
      if(Array.isArray(enderecamento)) {
        const valorEnderecamentos = enderecamento.map(nome => this.values[nome]).join('__');        
        return valorEnderecamentos
      }
      if (enderecamento) {
        return this.values[enderecamento]
      } else {
        return ["Não existe valor disponível"]
      }
    },

    exibeValueMultiForm () {
      // if (this.exportarDados) {
      //   let dadosPorformularios = [];
      //   let dados;
      //   let index = 0;

      //   lista
      // }
    },

    verificadorDeValidacao(event) {
      const hasInput = this.validation.find(input => input.name === event.name) || false;
      if (!hasInput) {
        this.validation.push(event)
      } else {
        this.validation = this.validation.map(input => {
          if (input.name === event.name) {
            input = event
          }
          return input
        })
      }
    },

    existeCampoComErroDeValidacao() {
      if (!this.validation.length) return false;
      return this.validation.some(input => input.hasErrors === true);
    },

    mostraMessagemErroValidacao() {
      criarToast({
        tipo: 'error',
        mensagem: 'Há campos obrigatórios não preenchidos, por favor verifique antes de salvar.'
      })
    },

    exibeValue () {
      if (this.exportarDados) {
        if (this.existeCampoComErroDeValidacao()) {
          this.mostraMessagemErroValidacao()
          return
        }
        let dadosPorformularios = [];
        let dados;
        let index = 0;

        let listaDeFormularios = [...this.formularioDinamico]
        // listaDeFormularios.push({ ctrl_tarefa_id: null, dados: this.form, id: null})

        // console.log('Formulario array ids: ' ,this.arrayFormId)


        listaDeFormularios.forEach(form => {
          dados = {};
          dados['ctrl_formulario_dinamico_id'] = form.id;
          dados['ctrl_formulario_id'] = form.id;
          dados['ctrl_tarefa_id'] = this.arrayFormId[0].ctrl_tarefa_id;
          form.ctrl_tarefa_id = this.arrayFormId[0].ctrl_tarefa_id
          // form.id = form.dados.id

          form.corpo.forEach(listaDeCampos => {
            if ( listaDeCampos.type.includes('hidden') ||
              (typeof this.values[listaDeCampos.name] != 'undefined' &&
             this.values[listaDeCampos.name] != '')) {
              dados[listaDeCampos.name] = this.values[listaDeCampos.name];
            }
          })
          dadosPorformularios.push(dados);
          index = index + 1;
        })

        // console.log('Dados por formularios: ', dadosPorformularios)

        let valores = this.limparIndicesObj();

        this.$emit('dadosFormularioDinamicoEmit', {
          values: {
            ...valores
          },
          formularios: listaDeFormularios,
          dadosPorformularios: dadosPorformularios
        });

        criarToast({
          tipo: 'success',
          mensagem: 'Formulário salvo com sucesso!'
        })

        return
      }

      if(this.endpoint) {
        this.salvarDadosFormulario(this.values, this.endpoint)
      }
    },

    limparIndicesObj () {
      let valores = {};
      for (const indice in this.values) {
        //const novoIndice = indice;
        valores[indice] = this.values[indice];
      }

      return valores;  
    },

    setarVariaveisMinimizado () {
      const formulario = JSON.parse(localStorage.getItem(process.env.VUE_APP_FORMULARIO_DINAMICO_MINIMIZADO + '' +((this.identificador != null) ? `_${this.identificador}` : '')))
      
      if (formulario !== null) {
        if (Object.keys(formulario).length) {
          this.values = formulario.values ? formulario.values : {}
        }
      }
    },

    handleRegrasDadosExternos (campo) {
      let retorno = true

      if (!this.dadosExternos) {
        return retorno
      }

      if (typeof this.dadosExternos === 'object') {       
        if (campo && campo.expressoes_logicas_externas && campo.expressoes_logicas_externas.length) {

          let parsedRegras = campo.expressoes_logicas_externas.map(regra => {
            const valorPath = this.recuperarValorPeloPath(this.dadosExternos, regra.path)

            const comando =  regra.ctrl_expressao_booleana.comando

            if (regra.option_value) {
              // let optionsFinal = {}
              for (const key in campo.options) {
                if(campo.options[key] == regra.option_value) {
                  if (this.verificadorCondicional(`"${valorPath}" ${comando} "${regra.value}"`, campo)) {
                    // optionsFinal.push({[key]: campo.options[key]})
                    campo.options = regra.options
                  }
                }
              }

              // campo.options = Object.assign({}, ...optionsFinal)

              // campo.options = optionsFinal
              //  = [...campo.options.filter(option => {
              //   console.log('Option tem regra: ', option, regra, `"${valorPath}" ${comando} "${regra.value}"`)

              //   return true
              // })]
              // console.log('Campo options regra: ', regra.option_value , campo)
            }

            return `${regra.operador_logico ? regra.operador_logico : ''} "${valorPath}" ${comando} "${regra.value}"`

            // if (regra.options && regra.options.length && valorPath == regra.value) {
            //   campo.options = campo.options.filter(campoOption =>
            //     !regra.options.some(regraOption => regraOption.val === campoOption.value)
            //   )
            // } else {
            //   retorno = valorPath == regra.value
            // }

          })

          parsedRegras = parsedRegras.join(' ');

          retorno = this.verificadorCondicional(parsedRegras)
        }
      }
      return retorno
    },

    recuperarValorPeloPath(obj, path) {
      return path.split('.').reduce((acc, key) => acc && acc[key], obj);
    },

    criarMapaDependenciasCampos() {
      // Cria um mapa de dependências entre campos computados
      const todosCampos = this.form.flatMap(form => form.corpo || []);
      this.mapaDependencias = criarMapaDependencias(todosCampos);
    },

    processarCamposComputados() {
      // Processa todos os campos computados no formulário
      this.form.forEach(form => {
        if (form.corpo) {
          form.corpo.forEach(campo => {
            if (campo.computed && campo.computed.format) {
              const valorComputado = processarCampoComputado(campo, this.values);
              this.$set(this.values, campo.name, valorComputado);
            }
          });
        }
      });
    },

    atualizarCamposComputadosDependentes(nomeCampo) {
      // Quando um campo muda, atualiza todos os campos que dependem dele
      const camposDependentes = this.mapaDependencias[nomeCampo] || [];
      
      camposDependentes.forEach(nomeCampoDependente => {
        // Encontra a definição do campo dependente
        let campoDependente = null;
        this.form.forEach(form => {
          if (form.corpo) {
            const encontrado = form.corpo.find(c => c.name === nomeCampoDependente);
            if (encontrado) {
              campoDependente = encontrado;
            }
          }
        });

        if (campoDependente && campoDependente.computed) {
          const valorComputado = processarCampoComputado(campoDependente, this.values);
          this.$set(this.values, campoDependente.name, valorComputado);
        }
      });
    }
  },
  watch: {
    values: {
      handler(newValue, oldValue) {
        if (newValue != oldValue) {
          this.$emit('dadosPreenchidosNoFormularioDinamico', {...JSON.parse(JSON.stringify(newValue))});
          
          // Atualizar campos computados quando um valor mudar
          for (const key in newValue) {
            if (oldValue && oldValue[key] !== newValue[key]) {
              this.atualizarCamposComputadosDependentes(key);
            }
          }
        }


        // const formulario = JSON.parse(localStorage.getItem(process.env.VUE_APP_FORMULARIO_DINAMICO_MINIMIZADO + '' +((this.identificador != null) ? `_${this.identificador}` : '')))
        // console.log('Recuperando form minimizado: ', formulario)
        // if (Object.keys(formulario).length) {
        //   this.values = formulario.values ? formulario.values : {}
        // }

        // if(this.exportarDados) {
        //   this.$emit('dadosAoAtualizarFormularioEmit', { 
        //     values: newValue,
        //     config: this.listaDeFormularios[0],
        //     configArray: this.listaDeFormularios
        //   });
        // }

      },
      deep: true
    }
  }
}
</script>

<style lang="scss">
.input-padrao-formulate {
  border: solid 0px #ccc;
  margin-top: 5px;

  label {
    font-size: 12px !important;
  }

  .v-input {
    fieldset {
      height: 36px !important;
    }
  }

  .v-textarea {
    fieldset {
      height: auto !important;
    }
  }
}

.input-requisicao {
  label {
    position: relative;
    display: block;
    font-size: 12px !important;
    margin-top: -2px !important;
    margin-bottom: 2px !important;
  }


  .v-text-field--enclosed {
    fieldset {
      height: 36px !important;
    }
  }

  .v-input--is-label-active {
    fieldset {
      height: auto !important;
    }
  }
}

// Estilo para campos do formulário dinâmico
.form-field-dynamic {
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
  
  .v-text-field,
  .v-select {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  // Garante altura consistente para todos os campos
  .v-input {
    margin-top: 0 !important;
    padding-top: 0 !important;
  }

  .v-input__control {
    min-height: 40px !important;
  }

  // TextField e Select com mesma altura
  .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot,
  .v-select.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot {
    min-height: 40px !important;
  }

  // Fieldset com altura consistente
  fieldset {
    min-height: 40px !important;
  }

  // Textarea com altura automática
  &.v-textarea .v-input__control,
  &.v-textarea fieldset {
    min-height: auto !important;
  }

  // Remove margem extra dos detalhes
  .v-text-field__details {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    padding-top: 4px !important;
  }

  // Alinha o conteúdo interno
  .v-input__slot {
    align-items: center !important;
  }

  // Radio button wrapper
  .radio-input-wrapper {
    margin-bottom: 0 !important;
  }
}
</style>